/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecruiteeConnectionConfig interface.
 */
export function instanceOfRecruiteeConnectionConfig(value) {
    if (!('isMergeDuplicateCandidatesEnabled' in value) || value['isMergeDuplicateCandidatesEnabled'] === undefined)
        return false;
    return true;
}
export function RecruiteeConnectionConfigFromJSON(json) {
    return RecruiteeConnectionConfigFromJSONTyped(json, false);
}
export function RecruiteeConnectionConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isMergeDuplicateCandidatesEnabled': json['isMergeDuplicateCandidatesEnabled'],
    };
}
export function RecruiteeConnectionConfigToJSON(json) {
    return RecruiteeConnectionConfigToJSONTyped(json, false);
}
export function RecruiteeConnectionConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'isMergeDuplicateCandidatesEnabled': value['isMergeDuplicateCandidatesEnabled'],
    };
}
